import styled from "@emotion/styled";

const Empty = styled.div<{ space: number }>`
	height: ${(props) => props.space}px;
	width: 100%;
`;

export default Empty;
